import { IonBackButton, IonButton, IonButtons, IonCard, IonCardContent, IonCol, IonContent, IonFooter, IonGrid, IonHeader, IonIcon, IonImg, IonMenuButton, IonPage, IonRow, IonText, IonTitle, IonToolbar, useIonLoading, useIonRouter, useIonViewWillEnter } from '@ionic/react';
import { chevronBackOutline, informationCircleOutline, logInOutline, personCircleOutline, refresh } from 'ionicons/icons';
import { useAppContext } from '../AppProvider';

const About: React.FC = () => {

  const { SWFullHorizLogo, textLogoLoaded, fadeInTextLogo } = useAppContext();

  useIonViewWillEnter(() => {
      document.body.classList.remove('dark');
  });
  
  return (
    <IonPage>
      <IonHeader>
        <IonToolbar>
            <IonButtons slot='start'>
                {/*<IonButton routerLink='/'><IonIcon icon={chevronBackOutline}></IonIcon> Home</IonButton>*/}
                <IonBackButton color={'tertiary'}>Back</IonBackButton>
            </IonButtons>
            <IonTitle><IonImg className={textLogoLoaded ? 'fade-in' : 'fade-out'} src={SWFullHorizLogo} onIonImgDidLoad={fadeInTextLogo}></IonImg></IonTitle>
            <IonButtons slot='end'>
                <IonButton color={'tertiary'} routerLink='/register'>Sign Up</IonButton>                        
            </IonButtons>
        </IonToolbar>
      </IonHeader>
      <IonContent className="ion-padding home-content-bg-1" fullscreen>
        <div>
            <h1 className='ion-text-center'>About SoloWise</h1>
        </div>
        <IonGrid fixed>
            <IonRow class='ion-justify-content-center'>
                <IonCol size='12' sizeMd='10' sizeLg='10' sizeXl='8'>
                    <IonCard>
                        <IonCardContent id='AboutContent'>
                            <p ><IonText color={'tertiary'}><strong>SoloWise offers you peace of mind wherever life takes you — whether hiking solo, meeting someone new, or simply living independently. By recording where you'll be, when you expect to check in, and who should be notified if you don't, you create an extra layer of connection that provides peace of mind to you and those who care about you.</strong></IonText></p>

                            <hr />

                            <p>In today's world, peace of mind is priceless. SoloWise brings a modern approach to an old, trusted practice: letting someone know where you'll be and when you plan to return. Whether you're heading out on a hike, meeting someone new, showing a property as a professional realtor, or simply living alone and wanting an added layer of connection, our service ensures you're never truly on your own. With just a few quick steps, you can leave behind a digital “note” that becomes an invaluable resource if you don't check in as expected.</p>

                            <p>The flexibility of SoloWise means it's as useful in the backcountry as it is in the city. Solo adventurers can record their intended routes, hunters and recreationalists can log their locations, and those meeting strangers — whether socially or professionally — can provide crucial details in advance. The same system offers reassurance to aging seniors or anyone in a vulnerable situation, regardless of whether they're in an urban, suburban, rural, or wilderness setting.</p>

                            <p>Every session, called a Timer, prompts users to record at least the essentials: where they're staying or going, who they'll be with, when they expect to check in, and who should be contacted if they don't. For added thoroughness, you can also save and select details about vehicles, children, or pets that accompany you. These profiles are reusable, so there's no need to re-enter them each time.</p>
                            
                            <p>If your Timer expires without a check-in, SoloWise first contacts you with a reminder. If you don't respond, your emergency contacts automatically receive an alert containing all of your pre-recorded details — information that can be quickly forwarded to authorities or search and rescue teams, making the difference when time matters most.</p>

                            <p className='ion-margin-top'>Contact our Member Support Team at support@besolowise.com</p>

                            <hr className='ion-margin' />

                            <div className='ion-margin-bottom ion-margin-top ion-text-center'>
                              <IonButton className='ion-margin' color={'secondary'} type='button' expand='block' routerLink='/register'>
                                  Sign Up Now <IonIcon icon={personCircleOutline} slot='end'></IonIcon>
                              </IonButton>
                            </div>
                        </IonCardContent>
                    </IonCard>
                </IonCol>
            </IonRow>
        </IonGrid>
      </IonContent>
    </IonPage>
  );
};

export default About;
